import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import CategoryQuestions from '../blocks/category-questions';
import Footer from '../blocks/footer';
import Header from '../blocks/header';
import UpArrow from '../blocks/up-arrow';
import Notifications from '../blocks/notifications';
import UsefulInformation from '../blocks/useful-information';
import Feedback from '../blocks/feedback';
import Gdpr from '../blocks/gdpr-banner';
import Search from '../blocks/search';
import Answers from '../blocks/answers';
import CustomSelect from '../blocks/custom-select';
import SortSelect from '../blocks/sort-select';
import AnswersList from '../blocks/answers-list';
import SystemSwitcher from '../blocks/system-switcher';
import UtilityTable from '../blocks/utility-table';
import DownloadAgreement from '../blocks/download-agreement';

$(() => {
	svg4everybody();

	const gdpr = new Gdpr();
	gdpr.init();

	const categoryQuestions = new CategoryQuestions();
	categoryQuestions.init();

	const footer = new Footer();
	footer.init();

	const header = new Header();
	header.init();

	const upArrow = new UpArrow();
	upArrow.init();

	const notifications = new Notifications();
	notifications.init();

	const usefulInformation = new UsefulInformation();
	usefulInformation.init();

	const feedback = new Feedback();
	feedback.init();

	const search = new Search();
	search.init();

	const answers = new Answers();
	answers.init();

	const customSelect = new CustomSelect();
	customSelect.init();

	const sortSelect = new SortSelect();
	sortSelect.init();

	const answersList = new AnswersList();
	answersList.init();

	const systemSwitcher = new SystemSwitcher();
	systemSwitcher.init();

	const utilityTable = new UtilityTable();
	utilityTable.init();

	const downloadAgreement = new DownloadAgreement();
	downloadAgreement.init();
});



// WEBPACK FOOTER //
// ./app/scripts/app.js